export default "__VITE_ASSET__HgII$g_N__"